import mobileAndroid from './mobileAndroid'
import mobileIOS from './mobileIOS'

export default { mobileAndroid, mobileIOS } 
